import { Outlet, Navigate } from "react-router-dom";
import { useCombinedStore } from "../store";

export default function LoginRoute() {
  // const { auth } = useSelector((state: RootState) => state); TODO: zustand
  const authUserZustand = useCombinedStore((state) => state.authUserZustand);

  const token = authUserZustand?.Token;
  const isAuthenticated = !!token;

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
}
